import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import Swal from 'sweetalert2'
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
import { DocumentService } from 'src/app/Services/document/Documentservice';
import { LoadFileModel } from 'src/app/Model/LoadFile.Model';


@Component({
  selector: 'attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss']
})
export class AttachmentComponent implements OnInit {

  //En este input se debe ingresar el nombre del BlobContainer que se va a afectar
  //En caso de no existir se crea el contenedor.
  //@Input('sfcontrol') _sfcontrol: SpecialFormControl;
  @Output('blurAction') _blurAction: EventEmitter<any> = new EventEmitter();
  @Output('enterKey') _enterKey: EventEmitter<any> = new EventEmitter();
  @Output('saveDocument') saveDocument: EventEmitter<any> = new EventEmitter();
  @Input('preRowKey') preRowKey: string;
  @Input() container: string;
  @Input() masterContainer: string;
  @Input() docfolder: string;
  @Input() uploadbool: boolean;
  @Input() admitedTypes: string;
  @Input() isBSPFile: boolean;

  formFields = [];
  blobService;
  blobArray = [];
  files: File[] = [];
  tokenSAS: string;
  upload: boolean = false;
  admitedTypesArray : any = [];
  compareType: string;
  insertedItems: string;
  event: any;
  uploadButton: boolean = false;
  response;

  fileData: File = null;
  previewUrl: any = null;
  fileUploadProgress: string = null;
  uploadedFilePath: string = null;
  constructor(
    private readonly SpinnerService: NgxSpinnerService,
    private readonly translate: TranslateService,
    private readonly documentService: DocumentService
  ) { }

  ngOnInit() {
    this.admitedTypesArray = this.admitedTypes != undefined ? this.admitedTypes.split(";") : []
  }

  async onPreview(event) {

    let i = 1;
    this.blobArray = [];
    this.event = event
    let blobs = event.addedFiles;
    this.event.addedFiles = [];


    for await (const blob of blobs) {

      if (blob.name.includes(this.admitedTypesArray))
      {
        if(blob.size <= 2097152){
          this.blobArray.push({ "blob": blob, "downloadLink": blob.name })

          this.event.addedFiles.push(blob)
          this.uploadButton = true
        }
        else{
          Swal.fire({
            title: 'Error!',
            text: this.translate.instant('Document.Messages.limitSize'),
            icon: 'error',
          })
          this.Clean()
        }
      }
      else
      {
        Swal.fire({
          title: 'Error!',
          html: `${this.translate.instant('Document.Messages.9')} ${this.admitedTypesArray}, ${this.translate.instant('Document.Messages.10')} ${this.docfolder}`,
          icon: 'error',
          confirmButtonText: 'Cerrar'
        })
        this.Clean()
      }

    }

  }

  async onSubmitPreview(event)
  {
    this.SpinnerService.show()
    this.insertedItems =  ""
    event.addedFiles.forEach(async element => {

      this.insertedItems +=  element.name + "<br>"

      try {
        //Eliminar los archivos que estuvieran en la carpeta
        await this.deleteAllFolder();

        //Obtener el archivo en base64
        let encodedFile = await this.getBase64(element).then(x => x);

        let nameSplit = element.name.split(".")
        let fileName = "";
        if(!this.isBSPFile)
          fileName = nameSplit[0].replaceAll(/[^\w]/gi, '') + "." + nameSplit[1];
        else 
          fileName = nameSplit[0] + "." + nameSplit[1];

        let fileToUpload = new LoadFileModel();
        fileToUpload.fileB64 = encodedFile;
        fileToUpload.fileName = element.name;
        fileToUpload.BlobPath = this.container.toLowerCase()+'/'+this.docfolder;
        fileToUpload.fileType = element.type;
        fileToUpload.container = this.masterContainer;

        let res = await this.documentService.uploadFile(fileToUpload);

        this.response = {
          Name: fileName,
          Url: res.replace('%2F', '/')
        }

        this.saveDocument.emit(this.response);

        this.SpinnerService.hide()

        Swal.fire({
          icon: 'success',
          html: `${this.translate.instant('Document.Messages.8')} ${this.container} <br><br> ${this.insertedItems}`,
          confirmButtonText: this.translate.instant('Document.Button.Close')
        })  

        }
        catch (error) {
          this.SpinnerService.hide()
          Swal.fire({
            icon: 'error',
            html: `${this.translate.instant('Document.Messages.12')} ${this.container} ${this.translate.instant('Document.Messages.13')} <br><br> ${this.insertedItems}`,
            confirmButtonText: this.translate.instant('Document.Button.Close')
          })
        }
    });
    this.blobArray = [];
    this.uploadButton = false
  }

  public Clean()
  {
    this.blobArray = [];
    this.uploadButton = false
  }




  /* ------------------------------------------------------ */

  async deleteAllFolder() {
    let folderRoute = new LoadFileModel();
    folderRoute.BlobPath = this.container+'/'+this.docfolder;
    folderRoute.container = this.masterContainer;
    return await this.documentService.deleteAllFilesFromFolder(folderRoute)
  }
  

  preview() {
    // Show preview
    let mimeType = this.fileData.type;
    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    let reader = new FileReader();
    reader.readAsDataURL(this.fileData);
    reader.onload = (_event) => {
      this.previewUrl = reader.result;
    }
  }

  async getBase64(file) {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.toString());
      reader.onerror = error => reject(new Error(error.toString()));
    }).catch(() => {return null});
  }

}
